define('entities/calendar_events',[
  'app',
  'jquery',
  'underscore',
  'backbone',
  'settings'
], function (
  App,
  $,
  _,
  Backbone,
  Settings
) {
  'use strict';

  /**
   * Backbone model for a calendar event. Dates (start/end/recurrenceUntil) are
   * exchanged with the backend as epoch milliseconds.
   */
  var CalendarEvent = Backbone.Model.extend({
    idAttribute: 'secId',

    defaults: {
      secId: null,
      title: '',
      description: '',
      type: 'PERSONAL',
      status: 'CONFIRMED',
      category: 'OTHER',
      color: null,
      start: null,
      end: null,
      allDay: false,
      halfDayPart: 'FULL',
      recurrenceFreq: 'NONE',
      recurrenceInterval: 1,
      recurrenceByDay: null,
      recurrenceUntil: null,
      recurrenceCount: null,
      excludedDates: null,
      reminderMinutesBefore: null,
      groupSecId: null,
      groupName: null,
      occurrenceDate: null,
      canEdit: true
    },

    /** Create (POST) or update (PUT /{secId}) depending on secId presence. */
    save: function () {
      var json = this.toJSON();
      var hasId = !!this.get('secId');
      var url = hasId ?
        Settings.url('compuzz2', 'v2/calendar-events/' + this.get('secId')) :
        Settings.url('compuzz2', 'v2/calendar-events');

      return $.ajax({
        type: hasId ? 'PUT' : 'POST',
        url: url,
        contentType: 'application/json',
        data: JSON.stringify(json)
      });
    },

    /**
     * Delete the event. For a recurring series, passing an occurrenceDate
     * (yyyy-MM-dd) removes only that occurrence; otherwise the whole series.
     */
    destroy: function (occurrenceDate) {
      var params = {};
      if (occurrenceDate) {
        params.occurrenceDate = occurrenceDate;
      }
      return $.ajax({
        type: 'DELETE',
        url: Settings.url('compuzz2', 'v2/calendar-events/' + this.get('secId'), params)
      });
    }
  });

  var API = {

    getModel: function (json) {
      return new CalendarEvent(json || {});
    },

    /** Fetch the events visible to the current user within [from, to) (ms). */
    getEvents: function (fromMs, toMs) {
      return $.ajax({
        type: 'GET',
        url: Settings.url('compuzz2', 'v2/calendar-events', {from: fromMs, to: toMs})
      });
    },

    /** Whether the caller is a manager, their userpid secId, and the groups they belong to. */
    getContext: function () {
      return $.ajax({
        type: 'GET',
        url: Settings.url('compuzz2', 'v2/calendar-events/context')
      });
    },

    /** Pending vacation requests (manager only). */
    getPending: function () {
      return $.ajax({
        type: 'GET',
        url: Settings.url('compuzz2', 'v2/calendar-events/pending')
      });
    },

    approve: function (secId) {
      return $.ajax({
        type: 'POST',
        url: Settings.url('compuzz2', 'v2/calendar-events/' + secId + '/approve')
      });
    },

    reject: function (secId, reason) {
      return $.ajax({
        type: 'POST',
        url: Settings.url('compuzz2', 'v2/calendar-events/' + secId + '/reject',
          reason ? {reason: reason} : {})
      });
    }
  };

  App.reqres.setHandler('calendar:event:model', function (json) {
    return API.getModel(json);
  });
  App.reqres.setHandler('calendar:events', function (fromMs, toMs) {
    return API.getEvents(fromMs, toMs);
  });
  App.reqres.setHandler('calendar:context', function () {
    return API.getContext();
  });
  App.reqres.setHandler('calendar:pending', function () {
    return API.getPending();
  });
  App.reqres.setHandler('calendar:approve', function (secId) {
    return API.approve(secId);
  });
  App.reqres.setHandler('calendar:reject', function (secId, reason) {
    return API.reject(secId, reason);
  });

  return CalendarEvent;
});

